export function recordA4Prescription({ patient, invoiceNo, html }) {
  if (typeof window === "undefined" || process.env.NODE_ENV !== "development") {
    return;
  }
  window.__lastA4Prescription = {
    patient: patient ? { ...patient } : null,
    invoiceNo,
    html: html || ""
  };
  window.__printTestLog = window.__printTestLog || [];
  window.__printTestLog.push({
    kind: "a4-prescription",
    patient: window.__lastA4Prescription.patient,
    invoiceNo,
    at: Date.now()
  });
}
